import { createGlobalStyle } from 'styled-components'
import { theme } from './themes'

export const GlobalStyle = createGlobalStyle`
  :root {
    --primary-color: ${theme.primary};
    --secondary-color: ${theme.secondary};
    --accent-color: ${theme.accent};
    --text-color: ${theme.text};
    --text-light: ${theme.textLight};
    --text-dark: ${theme.textDark || theme.background};
    --background: ${theme.background};
    --background-light: ${theme.backgroundLight};
    --border-color: ${theme.borderColor};
    --shadow: ${theme.shadow};
    --shadow-hover: ${theme.shadowHover};
    --border-radius: 12px;
    --transition: all 0.3s ease;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    line-height: 1.6;
    color: var(--text-color);
    background-color: var(--background);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 0.5em;
  }

  p {
    margin-bottom: 1em;
  }

  a {
    color: var(--secondary-color);
    text-decoration: none;
    transition: var(--transition);
    
    &:hover {
      color: var(--primary-color);
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    
    @media (min-width: 768px) {
      padding: 0 2rem;
    }
  }

  .section {
    padding: 4rem 0;
    
    @media (min-width: 768px) {
      padding: 6rem 0;
    }
  }
`
